import dayjs, { Dayjs } from 'dayjs';

/**
 * Formats date to string with specified format.
 * @param {Date | number | string} date value in string, number or date object
 * @param {string} format string, default is 'YYYY-MM-DD'
 * @returns {string} formatted date
 */
export const formatDate = (
  date: string | number | Date | Dayjs,
  format = 'YYYY-MM-DD'
): string => {
  return dayjs(date).format(format);
};
